<template>
    <div class="agent-chat__conversation" role="log" aria-live="polite">
        <div v-if="!messages.length && !streamingContent" class="agent-chat__empty">
            {{ emptyText }}
        </div>

        <ChatMessage
            v-for="(message, index) in messages"
            :key="index"
            :role="message.role"
            :content="message.content"
            :can-apply="canApply && message.role === 'assistant'"
            :apply-label="applyLabel"
            @apply="$emit('apply', $event)"
        />

        <ChatMessage
            v-if="streamingContent || status === 'submitted'"
            role="assistant"
            :content="streamingContent"
            :streaming="true"
        />

        <div v-if="error" class="agent-chat__error" role="alert">
            {{ error }}
        </div>
    </div>
</template>

<script>
import ChatMessage from './Message.vue';

export default {
    name: 'AgentChatConversation',
    components: { ChatMessage },
    emits: ['apply'],
    props: {
        messages: {
            type: Array,
            default: () => [],
        },
        streamingContent: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: 'ready',
        },
        error: {
            type: String,
            default: null,
        },
        emptyText: {
            type: String,
            default: 'Inizia la conversazione con l\'assistente AI.',
        },
        canApply: {
            type: Boolean,
            default: false,
        },
        applyLabel: {
            type: String,
            default: 'Use in reply',
        },
    },
};
</script>

<style scoped>
.agent-chat__conversation {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.agent-chat__empty {
    margin: auto;
    color: #64748b;
    font-size: 14px;
    text-align: center;
}

.agent-chat__error {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 13px;
}
</style>
